const ja = {
  filter: {
    webSite: "Webサイト",
    all: "全て",
    status: "ステータス",
    date: "期間",
    selectDate: "日付を選択してください",
    remitted: "支払いが成功しました",
    remitting: "支払い中です",
    quicklySelect: {
      lab: "クイック選択",
      range: {
        today: "今日",
        lastWeek: "先週",
        lastMonth: "先月",
        lastYear: "去年"
      }
    }
  },
  tableColumns: {
    withdrawalTime: "出金日時",
    paymentBatchNo: "総シリアル番号",
    childFlowID: "サブシリアル番号",
    withdrawalFlowID: "出金番号",
    webSite: "Webサイト",
    groupName: "グループ",
    paymentAccount: "振込先口座",
    withdrawalAmount: "出金額",
    withdrawalFee: "出金手数料",
    transferredAmount: "受取金​​額",
    remittanceTime: "送金日時",
    remittanceStatus: "決済状況",
    orderStatus: "注文状況",
    status: "ステータス",
    noData: "データなし"
  }
};
export default ja;
